import {Text} from '../../1elements'
import ServiceNameSearch from '../../2compounds/ServiceNameSearch'
import ServiceSetForm from '../../3modules/ServiceSetImport/ServiceForm'

const ServiceForm = (
    {
        selectedServiceType, options, onChangeAutocomplete, selectedService, setSelectedService, setSearchKeyword,
        disabled, serviceData
    }
) => {
    console.log(serviceData)

    return(
        <div>

            {!disabled
                ?(
                    <>
                        <Text type={'smartFormInstruction'}>Attach service in <span>{selectedServiceType}</span></Text>
                        <ServiceNameSearch options={options} onChangeAutocomplete={onChangeAutocomplete}
                                           setSearchKeyword={setSearchKeyword}
                                           selectedService={selectedService} setSelectedService={setSelectedService} />
                    </>

                )
                :(
                    <ServiceSetForm selectedServiceType={selectedServiceType}
                                    serviceData={serviceData}
                                    disabled />
            )}


        </div>
    )
}

export default ServiceForm
